import React, { Component } from 'react'
import { LAND, PROJECT } from 'constants/geoConstants';
import { SALE_AVAILABLE } from 'constants/saleorderConstants';

import { connect } from 'react-redux';

import API_URL from "utils/HttpClient/apiRest"

import { getObject } from 'utils/Storage/StorageUtils';

const defaultStrokeColor = "black";
const defaultStrokeOpacity = "0.5";
const defaultStrokeWidth = "1";

class ProductSelectMap extends Component {
    constructor() {
        super();
        this.state = {
            zoom: 15,
            maptype: 'roadmap',
            productSelected: undefined,
            selectedProductId: null
        }

        this.map = undefined;
        this.infoWindow = undefined;
        this.clickedLatLng = undefined;
        this.centerProjectFeature = true;
        this.groundOverlays = [];

        this.arrayVisibleZoom = {
            PROJECT: 8,
            SQUARE: 12,
            LAND: 14
        };
    }

    componentWillReceiveProps(nextProps, prevState) {

        if (nextProps.projectParent != this.props.projectParent) {
            if (nextProps.projectParent != null) {
                this.clearMap();
                this.loadGeoJSON(nextProps.projectParent.value, true);
            }
        }

        if (nextProps.project != this.props.project) {
            if (nextProps.project != null) {
                this.clearMap();
                this.loadGeoJSON(nextProps.project.value, false);
            }
        }
        if (nextProps.product !== prevState.product) {
            if (nextProps.product != null) {
                this.drawSelectedProduct(
                    this.state.selectedProductId == null ? 0 : this.state.selectedProductId,
                    nextProps.product.id,
                    false
                );
                this.setState({ selectedProductId: nextProps.product.id });
            }
        }

    }

    componentDidMount() {
        this.initMap();
        this.addEventListeners();
        if (this.props.project != null) {
            this.loadGeoJSON(this.props.project.value, false);
            if (this.props.product != null) {
                setTimeout(() => {
                    this.drawSelectedProduct(
                        this.state.selectedProductId == null ? 0 : this.state.selectedProductId,
                        this.props.product.id,
                        false
                    );
                    this.setState({ selectedProductId: this.props.product.id });
                }, 4000);
            }
        } else {
            if (this.props.projectParent != null) {
                this.loadGeoJSON(this.props.projectParent.value, true);
            }
        }
    }

    initMap() {
        const options = {
            center: { lat: -17.6543291, lng: -63.3097676 },
            zoom: 15,
            mapTypeId: 'roadmap',
            disableDoubleClickZoom: true,
            mapTypeId: window.google.maps.MapTypeId.ROADMAP
        };
        this.map = new window.google.maps.Map(document.getElementById('map'), options);

        this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].push(document.getElementById('legendsContainer'));
    }

    clearMap() {
        if (this.centerProjectFeature == false) {
            this.updateProduct(null);
            this.removeGroundOverlays();
            this.removeFeatures();
            this.centerProjectFeature = true;
        }
    }

    removeFeatures() {
        this.map.data.forEach((feature) => {
            this.map.data.remove(feature);
        });
    }

    removeGroundOverlays() {
        this.groundOverlays.forEach(function (groundOverlay) {
            groundOverlay.setMap(null);
        });
    }

    addEventListeners() {
        /*this.map.addListener('zoom_changed', () => {
            this.setState({
                zoom: this.map.getZoom(),
            });
        });*/

        this.map.addListener('maptypeid_changed', () => {
            this.setState({
                maptype: this.map.getMapTypeId(),
            });
        });
    }

    loadGeoJSON(projectId, isProjectParent) {
        let user = getObject("user");
        let query = isProjectParent ? "?parentProjectId=" + projectId : "?projectId=" + projectId;
        query = query + "&companyId=" + user.company.id;
        this.map.data.loadGeoJson(API_URL + 'project/geojson' + query,
            null,
            (features) => {
                this.setMapZoom();
                this.setFeatureStyles();
                this.handleVisibility();
                this.handleShowInfoWindow();
                this.handleDblClickOverProjects();

                if (this.props.handleLoadingMap) {
                    console.log("entering here");
                    this.props.handleLoadingMap(false);
                }
            });
    }

    setFeatureStyles() {
        this.map.data.setStyle((feature) => {
            console.log("setStyle");
            let currentZoom = this.map.getZoom();
            let visibility = this.getTypeVisibility(feature, currentZoom);
            if (this.isProjectFeature(feature)) {
                this.loadGroundOverlay(feature);
                this.centerProject(feature);
            }
            return ({
                strokeColor: feature.getProperty('stroke-color'),
                strokeWeight: feature.getProperty('stroke-width'),
                strokeOpacity: feature.getProperty('stroke-opacity'),
                fillColor: feature.getProperty('fill-color'),
                fillOpacity: feature.getProperty('fill-opacity'),
                zIndex: feature.getProperty('z-index'),
                visible: visibility
            });
        });
        console.log("setFeaturesStyles finished");
    }

    isProjectFeature(projectFeature) {
        if (projectFeature != null) {
            return projectFeature.getProperty("type") === PROJECT;
        }
    }

    centerProject(projectFeature) {
        if (this.centerProjectFeature == true) {
            console.log("centerProject");
            let centerLatitude = projectFeature.getProperty("center-latitude");
            let centerLongitude = projectFeature.getProperty("center-longitude");
            this.setMapCenter(centerLatitude, centerLongitude);
        }
        this.centerProjectFeature = false;
    }

    cleanQueryParams(url) {
        if (url.indexOf("?") > 0) {
            return url.substring(0, url.indexOf("?"));
        }
        return url;
    }

    loadGroundOverlay(projectFeature) {

        let groundOverlayBackground = this.cleanQueryParams(projectFeature.getProperty("overlay-background"));
        let southWestLat = projectFeature.getProperty("overlay-southWestLat");
        let southWestLng = projectFeature.getProperty("overlay-southWestLng");
        let northEastLat = projectFeature.getProperty("overlay-northEastLat");
        let northEastLng = projectFeature.getProperty("overlay-northEastLng");

        let groundOverlayBounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(southWestLat, southWestLng),
            new window.google.maps.LatLng(northEastLat, northEastLng));

        let groundOverlay = new window.google.maps.GroundOverlay(groundOverlayBackground, groundOverlayBounds);
        groundOverlay.setMap(this.map);
        this.groundOverlays.push(groundOverlay);
    }

    handleShowInfoWindow() {
        this.infoWindow = new window.google.maps.InfoWindow();
        this.map.data.addListener('click', (event) => {
            this.clickedLatLng = event.latLng;
            const feature = event.feature;
            if (this.isLandFeature(feature)) {
                this.selectProduct(feature);
                //this.buildInfoWindow(feature, this.infoWindow);
            }
        });
    }

    handleDblClickOverProjects() {
        if (!this.isCommercialProjectSelected()) {
            this.map.data.addListener('dblclick', (event) => {
                var feature = event.feature;
                if (this.isProjectFeature(feature)) {
                    //isProjectSelected = true;
                    console.log("feature", feature);
                    let projectId = Number(feature.getProperty("id"));
                    let name = feature.getProperty("name");
                    this.props.handleProjectChange({
                        value: projectId,
                        label: name
                    });
                }
            });
        }
    }

    selectProduct(feature) {
        let currentProductId = feature.getProperty('id');
        if (this.isLandSaleAvailable(feature)) {
            this.drawSelectedProduct(this.state.selectedProductId, currentProductId, true);
            this.setState({ selectedProductId: currentProductId });
        }
    }

    buildInfoWindow(feature, infoWindow) {
        let content = this.buildContentInfo(feature);
        infoWindow.setContent(content);
        infoWindow.setPosition(this.calculatePolygonCenter(feature));
        infoWindow.setOptions({ pixelOffset: new window.google.maps.Size(5, 0) });
        infoWindow.open(this.map);
    }

    buildContentInfo(feature) {
        let currentProductId = feature.getProperty('id');
        let info = '<div><b>Nombre: </b>' + feature.getProperty('name') + '</div>' +
            '<div><b>Código: </b>' + feature.getProperty('code') + '</div>' +
            '<div><b>Estado: </b>' + feature.getProperty('status') + '</div>' +
            '<div><b>Superficie: </b>' + feature.getProperty('surface') + '</div>' +
            '<div><div style="float: left"><b>Categoria: </b></div>  <div style="margin-top: 3px; margin-left:3px; margin-right: 3px; float: left; width:12px; height:12px; background-color:' + feature.getProperty('category-color') + ';" ></div>' + feature.getProperty('category') + '</div>' +
            '<div><b>Cuadra: </b>' + feature.getProperty('block') + '</div>' +
            '<div><b>Precio: </b>' + feature.getProperty('price') + '</div>';

        /*if (this.isLandSaleAvailable(feature)) {
            this.drawSelectedProduct(this.state.selectedProductId, currentProductId, true);
            this.setState({ selectedProductId: currentProductId });
        }*/

        let content = '<div style="line-height: 1.5;">' + info + '&#160;' + '</div>';
        return content;
    }

    isLandFeature(feature) {
        return feature.getProperty('type') === LAND;
    }

    isLandSaleAvailable(feature) {
        return feature.getProperty('status') === SALE_AVAILABLE;
    }

    drawSelectedProduct(previousProductId, currentProductId, updateProduct) {
        this.map.data.forEach((feature) => {
            let id = feature.getProperty('id');
            if (Number(id) === Number(currentProductId)) {
                this.map.data.overrideStyle(feature, {
                    strokeWeight: '4.5',
                    strokeColor: 'red',
                    strokeOpacity: '1',
                    zIndex: '1000'
                });
                if (updateProduct) {
                    this.updateProduct(feature);
                }
            } else {
                if (Number(id) === Number(previousProductId)) {
                    this.map.data.overrideStyle(feature, {
                        strokeWeight: defaultStrokeWidth,
                        strokeColor: defaultStrokeColor,
                        strokeOpacity: defaultStrokeOpacity
                    });
                }
            }
        });
    }

    setLegendsDisplay() {
        if (this.isCommercialProjectSelected()) {
            document.getElementsByClassName("product-select-legend")[0].style.display = "block";
        }
    }

    updateProduct(feature) {
        console.log("Proyecto Comercial updateProduct", this.props.project);
        if (feature != null) {
            let product = {
                id: feature.getProperty('id'),
                name: feature.getProperty('name'),
                lotNumber: feature.getProperty('lotNumber'),
                block: feature.getProperty('block'),
                neighborhoodUnit: feature.getProperty('neighborhood-unit'),
                code: feature.getProperty('code'),
                surface: feature.getProperty('surface'),
                price: feature.getProperty('price'),
                projectName: this.props.project.label,
                totalPrice: feature.getProperty('total-price'),
                initialQuota: feature.getProperty('initial-quota'),
                monthlyQuota: feature.getProperty('monthly-quota'),
                cashPrice: feature.getProperty('cash-price'),
                isInversion: feature.getProperty('is-inversions'),
                cashSale: feature.getProperty('cash-sale'),
                creditSale: feature.getProperty('credit-sale'),
                status: feature.getProperty('status')
            };
            this.props.handleChange(product);
        } else {
            this.props.handleChange(null);
        }
    }

    calculatePolygonCenter(feature) {
        let bounds = new window.google.maps.LatLngBounds();
        let geometry = feature.getGeometry();

        let polygonCoords = [];
        geometry.forEachLatLng(function (latLng) {
            polygonCoords.push(latLng);
        });
        let i = 0;
        while (i < polygonCoords.length) {
            bounds.extend(polygonCoords[i]);
            i++;
        }
        return bounds.getCenter();
    }

    setMapCenter(lat, lng) {
        this.map.setCenter({ lat: Number(lat), lng: Number(lng) });
    }

    setMapZoom() {
        if (this.isCommercialProjectSelected()) {
            this.map.setZoom(16.6);
        } else {
            this.map.setZoom(11);
        }
    }

    getTypeVisibility(feature, zoom) {
        let type = feature.getProperty('type');
        return zoom >= this.arrayVisibleZoom[type];
    }

    isCommercialProjectSelected() {
        return this.props.project != null && this.props.project.id != 0;
    }

    handleVisibility() {
        this.map.addListener('zoom_changed', () => {
            let currentZoom = this.map.getZoom();
            this.updateVisibility(currentZoom);
        });
    }

    updateVisibility(currentZoom) {
        this.map.data.forEach((feature) => {
            let visibility = this.getTypeVisibility(feature, currentZoom);
            this.map.data.overrideStyle(feature, { visible: visibility });
        });
    }

    render() {
        return (
            <div id="app" >
                <div id="legendsContainer">
                    <div id="legend" className="product-select-legend">
                        <div className="text-center"><b>Estados</b></div>
                        <div>
                            <div className="product-select-status__label">
                                <div className="product-select-status__color product-select-status__available"></div>
                                <div>DISPONIBLE</div>
                            </div>
                        </div>
                        <div>
                            <div className="product-select-status__label">
                                <div className="product-select-status__color product-select-status__reserved"></div>
                                <div>RESERVADO</div>
                            </div>
                        </div>
                        <div>
                            <div className="product-select-status__label">
                                <div className="product-select-status__color product-select-status__busy"></div>
                                <div>VENDIDO </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="map" className="product-select__map" className="product-select__map">
                </div>
            </div>
        );
    }
}
export default connect(null, {})(ProductSelectMap);



// WEBPACK FOOTER //
// ./src/components/ProductSelectMap/ProductSelectMap.jsx